import { Image } from '@/components/common/image';
import { CopyClipboard } from '../common/copy-clipboard';
import { useTranslation } from 'react-i18next';
import { AgentV2PushContentDetailData } from '@/services/agent-v2-push-content-detail';
import { formatDateSmart } from '@/utils/date-formatter';

/** 左侧文章区域 */
export const LeftArticle: React.FC<{ details: AgentV2PushContentDetailData }> = ({ details }) => {
  const { t } = useTranslation();

  return (
    <div className='flex-1 h-full relative bg-white flex flex-col border-r border-r-[rgba(233,234,235,1)] py-[30px] px-6 pr-4 overflow-hidden'>
      <div className='flex-1 flex flex-col overflow-x-hidden overflow-y-auto'>
        <div className='text-xl font-semibold text-[rgba(0,0,0,1)] line-clamp-2'>
          {details?.contentTitle || ''}
        </div>
        <div className='w-[22.938rem] min-h-28 rounded-md bg-[rgba(234,236,240,1)] p-4 mt-5'>
          <div className='flex items-center justify-between pb-3'>
            <span className='text-sm text-[rgba(102,112,133,1)]'>{t('agent_dashboard.content_management.detail_modal.left_article.abstract')}</span>
            <CopyClipboard text={details?.summary || ''} className='size-5' iconClassName='size-5' />
          </div>
          <div className='text-sm text-[rgba(16,24,40,1)] leading-6'>
            {details?.summary || '-'}
          </div>
        </div>
        <div className='flex items-center mt-5'>
          <div className="size-5 rounded-[4px] flex-shrink-0 mr-1.5">
            <Image src={details?.userAvatar || ''} className="size-full rounded-[4px] object-cover" />
          </div>
          <span className='text-sm font-medium text-[rgba(102,112,133,1)]'>{details?.userName || ''}</span>
          <div className='w-[1px] h-4 rounded-full bg-[rgba(233,234,235,1)] mx-2'></div>
          <span className='text-sm  text-[rgba(102,112,133,1)]'>{formatDateSmart(details?.pushAt * 1000) || ''}</span>
        </div>
        <div className='flex-1 w-full mt-2'>
          <iframe
            title="article-content"
            className="w-full h-full bg-white"
            sandbox=""
            srcDoc={details?.content || ''}
          />
        </div>
      </div>
    </div>
  )
}
